import ActionHomeSection from "../components/HomeSection/ActionHomeSection";
import HomeSection from "../components/HomeSection/HomeSection";
import InformationHomeSection from "../components/HomeSection/InformationHomeSection";
import NewsHomeSection from "../components/HomeSection/NewsHomeSection";
import ServiceHomeSection from "../components/HomeSection/ServiceHomeSection";
import StatisticHomeSection from "../components/HomeSection/StatisticHomeSection";
import WaterSection from "../components/HomeSection/WaterSection";
import WorkHomeSection from "../components/HomeSection/WorkHomeSection";

const Home = () => {
  return (
    <>
      <div className="">
        <HomeSection />
      </div>

      <div className="">
        <ServiceHomeSection />
      </div>
      {/* <WaterSection />     */}

      <StatisticHomeSection />

      <NewsHomeSection />

      <ActionHomeSection />
      <InformationHomeSection />
      <WorkHomeSection />

      <div className="flex justify-center mt-20 mb-20 "></div>
    </>
  );
};

export default Home;
